import { ITEM } from "../_constants/actionConstants";
import axios from "axios";
import { BASE_URL } from "../_constants/urlConstants";
import raiseError from "./raiseError";
import raiseWarning from "./raiseWarning";

const add = (newItemData) => async (dispatch) => {
  dispatch({ type: ITEM.ADD });
  const apiEndpoint = `${BASE_URL}/api/BidItems`;
  try {
    const res = await axios.post(apiEndpoint, newItemData);
    if (res.data.message) {
      dispatch({ type: ITEM.ADD_REJECTED });
      raiseWarning(ITEM.ADD_REJECTED, res.data.message);
      return null;
    }
    dispatch({ type: ITEM.ADD_FULFILLED });
    return res.data;
  } catch (err) {
    dispatch({ type: ITEM.ADD_REJECTED });
    raiseError(ITEM.ADD_REJECTED, err.response.data);
  }
};

const update = (bidItemData) => async (dispatch) => {
  dispatch({ type: ITEM.EDIT });
  const apiEndpoint = `${BASE_URL}/api/BidItems`;
  try {
    const res = await axios.put(apiEndpoint, bidItemData);
    if (res.data.message) {
      dispatch({ type: ITEM.EDIT_REJECTED });
      raiseWarning(ITEM.EDIT_REJECTED, res.data.message);
      return null;
    }
    dispatch({
      type: ITEM.EDIT_FULFILLED,
      payload: res.data,
      projectId: res.data.projectId,
      bidItemId: res.data.bidItemId,
    });
    return true;
  } catch (err) {
    dispatch({ type: ITEM.EDIT_REJECTED });
    raiseError(ITEM.EDIT_REJECTED, err.response.data);
  }
};

const getAll = (projId) => async (dispatch) => {
  dispatch({ type: ITEM.FETCH_ALL });
  const apiEndpoint = `${BASE_URL}/api/BidItems/List/${projId}`;
  try {
    const biDetailsRes = await axios.get(apiEndpoint);
    dispatch({
      type: ITEM.FETCH_ALL_FULFILLED,
      projectId: projId,
      projItemList: biDetailsRes.data,
    });
    return;
  } catch (err) {
    dispatch({ type: ITEM.FETCH_ALL_REJECTED });
    raiseError(ITEM.FETCH_ALL_REJECTED, err.response.data);
  }
};

const get = (bidItemId, projectId) => async (dispatch) => {
  dispatch({ type: ITEM.FETCH_DETAILS });
  const apiEndpoint = `${BASE_URL}/api/BidItems/${bidItemId}`;
  try {
    const biDetailsRes = await axios.get(apiEndpoint);
    dispatch({
      type: ITEM.FETCH_DETAILS_FULFILLED,
      bidItemId,
      projectId,
      payload: biDetailsRes.data,
    });
    return;
  } catch (err) {
    dispatch({ type: ITEM.FETCH_DETAILS_REJECTED });
    raiseError(ITEM.FETCH_DETAILS_REJECTED, err.response.data);
  }
};

const locationHasLinks = (bidItemId, locationId) => async (dispatch) => {
  dispatch({ type: ITEM.GENERIC_REQUEST });
  const apiEndpoint = `${BASE_URL}/api/BidItems/LocationHasLinks/${bidItemId}/${locationId}`;
  try {
    const res = await axios.get(apiEndpoint);
    dispatch({ type: ITEM.GENERIC_REQUEST_FULFILLED });
    return res.data;
  } catch (err) {
    dispatch({ type: ITEM.GENERIC_REQUEST_REJECTED });
    raiseError(ITEM.GENERIC_REQUEST_REJECTED, err.response.data);
  }
};

const bidItemActions = {
  add,
  get,
  getAll,
  locationHasLinks,
  update,
};

export default bidItemActions;
